import { render, staticRenderFns } from "./CreditManagementModal.vue?vue&type=template&id=70b72fba&scoped=true"
import script from "./CreditManagementModal.vue?vue&type=script&lang=ts"
export * from "./CreditManagementModal.vue?vue&type=script&lang=ts"
import style0 from "./CreditManagementModal.vue?vue&type=style&index=0&id=70b72fba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b72fba",
  null
  
)

export default component.exports